<template>
  <li :class="['task-item', { completed: stepSeconds > 0 }]">
    <div class="text">{{ text }}</div>
    <div class="text">{{ stepTime }}</div>
  </li>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'TaskItem',
  props: {
    text: { type: String, required: true },
    substepIndex: { type: Number, required: true },
    stepsTime: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const stepSeconds = computed(() =>
      Number(props.stepsTime?.[props.substepIndex] ?? 0)
    );
    const stepTime = computed(() => `${stepSeconds.value.toFixed(2)} s`);
    return { stepSeconds, stepTime };
  },
};
</script>

<style scoped>
.task-item {
  display: flex;
  gap: 0.5em;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  padding: 8px 10px;
}

.completed {
  background: #f0fdf4;
}

.text {
  font-size: var(--fs-sm);
  line-height: 1.35;
  color: #1f2937;
}
</style>
